import classNames from "classnames/dedupe";
import type { FlattenedSectionProps } from ".";
import {
  getSuggestedQuestions,
  getVisibleQuestions,
} from "../../../hooks/useCoverGenius/useCoverGenius";
import { useEnvironmentValues } from "../../../hooks/environment/useEnvironment";
import { useLocale } from "../../../hooks/useLocale";
import { useCoverGeniusSeeMoreCoversState } from "../../../hooks/useCoverGeniusSeeMoreCoversState";
import { Preamble, Postamble } from "../Amble";
import { Question } from "./Question";
import { isQuestion } from "./Question/types";

export const CoverGeniusSection = ({
  ref,
  ...props
}: FlattenedSectionProps) => {
  const { title, preamble, postamble, preambleName, questions, className } =
    props;
  const classes = classNames("mobius", "mobius-section", className);
  const { site } = useEnvironmentValues();
  const { locale } = useLocale();
  const visibleQuestions = getVisibleQuestions(questions);
  const suggestedQuestions = getSuggestedQuestions(questions);
  const [showSeeMoreCoversTrigger] = useCoverGeniusSeeMoreCoversState();
  const coverGeniusQuestions = showSeeMoreCoversTrigger
    ? suggestedQuestions
    : visibleQuestions;

  return (
    <section data-testid="mobius-section" ref={ref} className={classes}>
      {title && <h2 className="mobius-section__title">{title}</h2>}
      <Preamble
        amble={preamble}
        ambleName={preambleName}
        site={site}
        locale={locale}
      />
      <div className="mobius-section__question-container">
        {coverGeniusQuestions.filter(isQuestion).map(question => (
          <Question key={question.name} {...question} />
        ))}
      </div>
      <Postamble amble={postamble} site={site} locale={locale} />
    </section>
  );
};

CoverGeniusSection.displayName = "Section";
